import React from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'

const GAMES = {
    snake: { id: 'snake', name: 'Snake Classic', description: 'Eat, grow, avoid walls.', cover: '/media/illustrations/sigma-1/8.png' },
    tictactoe: { id: 'tictactoe', name: 'Tic Tac Toe', description: '3 in a row to win.', cover: '/media/illustrations/sigma-1/14.png' },
    memory: { id: 'memory', name: 'Memory Match', description: 'Flip and match cards.', cover: '/media/illustrations/sigma-1/20.png' },
    '2048': { id: '2048', name: '2048', description: 'Merge tiles to 2048.', cover: '/media/illustrations/sigma-1/25.png' },
}

export default function GameDetail() {
    const { id } = useParams()
    const navigate = useNavigate()
    const game = id ? GAMES[id] : undefined

    return (
        <>
            <PageTitle breadcrumbs={[{ title: 'Games', path: '/admin/games', isSeparator: false, isActive: false }]}>
                {game ? game.name : 'Game'}
            </PageTitle>
            <div className='container py-4 px-3 px-sm-4'>
                <button className='btn btn-link p-0 mb-3' onClick={() => navigate(-1)}>
                    <i className='bi bi-arrow-left'></i> Back
                </button>
                <div className='card shadow-sm border-0 rounded-4'>
                    {game && (
                        <div className='row g-0'>
                            <div className='col-12 col-md-5'>
                                <div className='ratio ratio-4x3 rounded-top-4 rounded-start-md-4 overflow-hidden'>
                                    <img src={game.cover} alt={game.name} className='w-100 h-100 object-fit-cover' />
                                </div>
                            </div>
                            <div className='col-12 col-md-7'>
                                <div className='p-3 p-sm-4'>
                                    <h3 className='fw-bold mb-2'>{game.name}</h3>
                                    <p className='text-muted mb-4'>{game.description}</p>
                                    <div className='d-flex gap-2'>
                                        <a href='#play' className='btn btn-primary flex-grow-1'>Start</a>
                                        <button className='btn btn-light' onClick={() => navigator?.share ? navigator.share({ title: game.name, url: window.location.href }) : void 0}>Share</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!game && (
                        <div className='p-6 text-center'>
                            <p className='mb-3'>Game not found.</p>
                            <Link to='/admin/games' className='btn btn-primary'>Back to Games</Link>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}


